<template>
  <Modal @close="close">
    <div slot="modal-header">
      User Add
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center">
      <RegisterView is-callback @submit="onSubmit" />
    </div>
    <div slot="modal-footer">
      <el-button @click="close">
        {{ $t('general.close') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import RegisterView from '../../views/register/RegisterView';
export default {
  name: 'RegisterUserModal',
  components: { RegisterView, Modal },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    close() {
      this.$emit('close');
    },
    onSubmit(formData) {
      if (!formData.password) formData.generatePassword = true;

      this.$parse.Cloud.run('registerUser', formData, {})
        .then(async (response) => {
          this.$message.success(response.msg);
          this.close();
        })
        .catch((error) => {
          this.$message.error(JSON.stringify(error));
        });
    },
  },
};
</script>

<style scoped></style>
